import React from "react";
import { useI18n } from "@/i18n";

export default function LegalPage({ ns }) {
  const { t } = useI18n();
  const sections = t(`${ns}.sections`, []);
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-4xl px-6 lg:px-10 py-20 lg:py-24">
        <h1
          data-testid={`${ns}-title`}
          className="text-4xl lg:text-5xl text-slate-900 tracking-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {t(`${ns}.title`)}
        </h1>
        <p className="mt-3 text-sm text-slate-500">{t(`${ns}.updated`)}</p>
        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <section key={i} data-testid={`${ns}-section-${i}`}>
              <h2
                className="text-xl text-slate-900 font-medium"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {s.heading}
              </h2>
              <div className="mt-4 space-y-4 text-slate-700 leading-relaxed">
                {(s.paragraphs || []).map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
